import React from "react"
import { Button, Card, CardBody } from "reactstrap"
import { partnerLogoSrc, tierLabel } from "./partnerPayload"
import { isExpired } from "./bandLayout"

// The band renders only what is live, so a partner hidden by hand or out of contract would be
// invisible in its own editor. This is where they wait, greyed out, with the reason and a way back.

const OffBandZone = ({ partners, now, onRestore, onRemove }) => {
  if (!partners.length) return null

  return (
    <Card className="mb-3">
      <CardBody>
        <h6 className="mb-1">Not on the band ({partners.length})</h6>
        <p className="text-muted" style={{ fontSize: 13 }}>
          The band only renders what is live, so these would be invisible on the screen above.
        </p>

        <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
          {partners.map(partner => {
            const expired = isExpired(partner, now)

            return (
              <div key={partner.id} style={{ textAlign: "center", width: 120 }}>
                <div
                  style={{
                    width: 96,
                    height: 96,
                    margin: "0 auto",
                    background: "#fff",
                    borderRadius: 10,
                    padding: 12,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    filter: "grayscale(1)",
                    opacity: 0.55,
                  }}
                >
                  <img
                    src={partnerLogoSrc(partner.logoUrl)}
                    alt={partner.name}
                    style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                  />
                </div>
                <div style={{ fontSize: 12, fontWeight: 600, marginTop: 6 }}>{partner.name}</div>
                <div className="text-muted" style={{ fontSize: 11 }}>
                  {tierLabel(partner.tier)}
                </div>
                <div style={{ fontSize: 11, color: "#a4131e" }}>
                  {expired
                    ? `expired ${String(partner.endsAt).slice(0, 10)}`
                    : "hidden by hand"}
                </div>
                <Button
                  size="sm"
                  color="link"
                  className="p-0"
                  style={{ fontSize: 11 }}
                  title={
                    expired
                      ? "Puts it back on the band and clears the end date"
                      : "Puts it back on the band"
                  }
                  onClick={() => onRestore(partner)}
                >
                  Restore
                </Button>
                {" · "}
                <Button
                  size="sm"
                  color="link"
                  className="p-0 text-danger"
                  style={{ fontSize: 11 }}
                  title="Deletes the partner for good"
                  onClick={() => onRemove(partner)}
                >
                  Remove
                </Button>
              </div>
            )
          })}
        </div>

        <p className="text-muted mb-0 mt-3" style={{ fontSize: 11 }}>
          Restoring a partner whose contract ran out also clears its end date — otherwise it would
          drop straight back off the band.
        </p>
      </CardBody>
    </Card>
  )
}

export default OffBandZone
